<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
    >

    <v-toolbar-title>구매내역 리스트 </v-toolbar-title>
    <v-spacer></v-spacer>
    <!-- <v-spacer></v-spacer>
    <v-text-field
        v-model="search_keyword"
        label="유저 아이디"        
        hide-details="auto"
        color:red
    ></v-text-field>
    <v-btn 
        icon
        @click="OnClick_SearchUser()"
    >
        <v-icon>mdi-magnify</v-icon>
    </v-btn> -->
    </v-toolbar>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="order_list"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td><span :style="{ fontWeight: '900'}">{{row.item.PID}}</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.NICK}} ({{row.item.USER_ID}})</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.CREATE_DT}}</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.SWAP_NM}}</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.PRD_NM}}</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.PRICE}}</span></td>
            <td><span :style="{ fontWeight: '900'}">{{row.item.COIN_PRICE}}</span></td>
            

            <!-- <td>  <span :style="{ fontWeight: '900', color: row.item.ENABLE == 'Y' ? 'blue' : 'red' }">{{row.item.ENABLE}}</span></td>
            <td>  <span :style="{ fontWeight: '900', color: row.item.DESTINATION_TAG == 'Y' ? 'blue' : 'red' }">{{row.item.DESTINATION_TAG}}</span></td> -->
            <!-- <td v-if="dialog_selected_item.PROCESS_STATE == 'WAIT'"> -->
            <!-- <td>
                <v-btn width="120px"
                color="indigo"
                class='white--text'
                @click="OnClick_ShowPopup_EditCoin(row.item)">상세</v-btn>
            </td> -->
            <!-- <td v-else>
                <span :style="{ fontWeight: '900'}">{{row.item.DISPATCH_DT}}</span>
            </td> -->
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-card>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [            
            { text: '주문번호', value: 'pid' },
            { text: '유저아이디', value: 'user_id' },
            { text: '구매시간', value: 'coin_nm' },
            { text: '구매처', value: 'state' },
            { text: '상품', value: 'datetime' },
            { text: '가격', value: 'manage' },
            { text: '코인가격', value: 'manage' },
        ],
        order_list:[],
        total_count:0,
        search_keyword:'',

        dialog_selected_item: {},
        dialog_popup:false,
        dialog_cancel_commment:'',


        dropdown_items: ['DONE', 'CANCEL'],
        dropdown_selected: null,
        dropdown_open: false,
    }),

    created()
    {
        console.log("TEST");
        this.Load_OrderList();
    },

    methods:{
        ...mapActions([
            "QUIZANDCASH_CPU_GET_USER_BUY_PRODUCTS",
        ]),
        Load_OrderList()
        {
            
            this.QUIZANDCASH_CPU_GET_USER_BUY_PRODUCTS().then((body_data)=>{
                this.order_list = body_data.data.result_data;
                console.log(JSON.stringify( body_data));

            });
        },

        formatCoin(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString();
        },
        toggleDropdown() {
            this.dropdown_open = !this.dropdown_open
        },
        selectItem(item) {
            this.dropdown_selected = item
            this.dropdown_open = false
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdown_open = false
            }
        }
        
    },
    computed: {
        
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
.dialog_title_text {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 6px;
    margin-top: 6px;
}

.dialog_info_text {
    font-weight: bold;
    font-size: 16px;
    margin-top: 7px;
}

.dropdown {
  position: relative;
  width: 200px;
}

.dropdown-button {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: white;
  text-align: left;
  cursor: pointer;
}

.dropdown-menu {
    position: absolute;
  top: 100%;
  left: 0;
}

.dropdown-menu li {
  padding: 10px;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}

@media (max-width: 600px) {
    .v-data-table {
        overflow-x: auto;
    }
    .v-toolbar__content {
        flex-wrap: wrap;
        height: auto !important;
        padding: 8px;
        gap: 4px;
    }
}
</style>
